import { FC } from "react";
import Stack from "../components/stack";
import Heading from "../components/heading";
import Body from "../components/body";
import Button from "../components/button";
import CollectableImage from "../assets/uos-banner.png";
import LogoImage from "../assets/uos-logo.png";
import NFTImageOne from "../assets/unicornsonsol/1580.png";
import NFTImageTwo from "../assets/unicornsonsol/2890.png";
import NFTImageThree from "../assets/unicornsonsol/4984.png";
import NFTImageFour from "../assets/unicornsonsol/6379.png";
import Box from "../components/box";
import { HorizontalTicker } from "react-infinite-ticker";
import Responsive from "../components/responsive";

const Collectable: FC = () => {
  return (
    <Box
      localStyles={{
        display: "flex",
        padding: "var(--scale-72) 0",
        justifyContent: "center",
        alignItems: "center",

        background: "var(--background)",
        backgroundImage: `linear-gradient(to bottom,rgb(0 0 0 / 60%),rgb(0 0 0 / 60%)),url("${CollectableImage}")`,
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",

        "@media (min-width: 1120px)": {
          paddingTop: "112px",
          height: "100vh",
        },
      }}
    >
      <Stack
        direction="VERTICAL"
        localStyles={{
          textAlign: "center",
          gap: "var(--scale-24)",
          "@media (min-width: 600px)": {
            gap: "var(--scale-24)",
          },
        }}
      >
        <Stack
          direction="VERTICAL"
          localStyles={{ width: "100%", padding: "0 var(--scale-48)" }}
          space={48}
        >
          <Stack direction="VERTICAL" space={36}>
            <img
              src={LogoImage}
              alt="Unicorns on sol logo"
              style={{ maxWidth: "250px", margin: "0 auto" }}
            />
            <Responsive below={599}>
              <Heading level="2">Unicorns On Sol</Heading>
            </Responsive>
            <Responsive above={600}>
              <Heading level="1">Unicorns On Sol</Heading>
            </Responsive>
          </Stack>
        </Stack>

        <Stack
          direction="VERTICAL"
          space={36}
          localStyles={{ marginBottom: 24 }}
        >
          <Body
            size="L"
            weight="BOLD"
            localStyles={{
              maxWidth: 664,
              margin: "0 auto",
              padding: "0 var(--scale-48)",
            }}
          >
            Unicorns On SOL is a Collection of 7,777 NFTs on Solana that pays
            tribute to @BasementRon and the Unicorn Fart Dust Community. All
            Royalties go to Ron directly.
          </Body>

          <Button
            as="a"
            variant="PRIMARY"
            size="L"
            href="https://magiceden.io/marketplace/unicorns_on_sol"
            target="_blank"
            localStyles={{
              maxWidth: 240,
              alignSelf: "center",
              background: "#e158aa",
              color: "black",
              borderColor: "#e158aa",
            }}
          >
            Buy on Magic Eden
          </Button>
        </Stack>

        <Box
          localStyles={{
            marginTop: 60,
            marginBottom: 60,
            "> div > div": {
              flex: "0 0 auto",
              textAlign: "center",
              alignItems: "center",
            },
          }}
        >
          <HorizontalTicker duration={43000}>
            <Stack direction="HORIZONTAL" localStyles={{ padding: 24 }}>
              <img
                src={NFTImageOne}
                alt="Unicorns on sol logo"
                style={{
                  maxWidth: "250px",
                  margin: "0 auto",
                  borderRadius: 24,
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.25)",
                }}
              />
            </Stack>
            <Stack direction="HORIZONTAL" localStyles={{ padding: 24 }}>
              <img
                src={NFTImageTwo}
                alt="Unicorns on sol logo"
                style={{
                  maxWidth: "250px",
                  margin: "0 auto",
                  borderRadius: 24,
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.25)",
                }}
              />
            </Stack>
            <Stack direction="HORIZONTAL" localStyles={{ padding: 24 }}>
              <img
                src={NFTImageThree}
                alt="Unicorns on sol logo"
                style={{
                  maxWidth: "250px",
                  margin: "0 auto",
                  borderRadius: 24,
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.25)",
                }}
              />
            </Stack>
            <Stack direction="HORIZONTAL" localStyles={{ padding: 24 }}>
              <img
                src={NFTImageFour}
                alt="Unicorns on sol logo"
                style={{
                  maxWidth: "250px",
                  margin: "0 auto",
                  borderRadius: 24,
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.25)",
                }}
              />
            </Stack>
            <Stack direction="HORIZONTAL" localStyles={{ padding: 24 }}>
              <img
                src={NFTImageOne}
                alt="Unicorns on sol logo"
                style={{
                  maxWidth: "250px",
                  margin: "0 auto",
                  borderRadius: 24,
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.25)",
                }}
              />
            </Stack>
            <Stack direction="HORIZONTAL" localStyles={{ padding: 24 }}>
              <img
                src={NFTImageTwo}
                alt="Unicorns on sol logo"
                style={{
                  maxWidth: "250px",
                  margin: "0 auto",
                  borderRadius: 24,
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.25)",
                }}
              />
            </Stack>
            <Stack direction="HORIZONTAL" localStyles={{ padding: 24 }}>
              <img
                src={NFTImageThree}
                alt="Unicorns on sol logo"
                style={{
                  maxWidth: "250px",
                  margin: "0 auto",
                  borderRadius: 24,
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.25)",
                }}
              />
            </Stack>
            <Stack direction="HORIZONTAL" localStyles={{ padding: 24 }}>
              <img
                src={NFTImageFour}
                alt="Unicorns on sol logo"
                style={{
                  maxWidth: "250px",
                  margin: "0 auto",
                  borderRadius: 24,
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.25)",
                }}
              />
            </Stack>
          </HorizontalTicker>
        </Box>
      </Stack>
    </Box>
  );
};

export default Collectable;
